/****************************************************************************
 * COPYRIGHT (c) 2025 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Chip, IconButton, Grid2 } from "@mui/material";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import ApplicationModal from "../ApplicationModal/ApplicationModal";
import CloseIcon from "@mui/icons-material/Close";
import "./ApplicationDetailsCPU.css";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  borderRadius: "5px",
  p: 4,
};

function ApplicationDetailsCPU({
  architectures,
  submissionData,
  postCallTheNewSubmission,
}) {
  const [cpuTypes, setCpuTypes] = useState([]);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const name = "CPU";
  useEffect(() => {
    if (
      submissionData &&
      Object.keys(submissionData).length > 0 &&
      submissionData.targeting &&
      submissionData.targeting.architectureTypesInclusions.length > 0
    ) {
      let newArchitectureInclusions = [
        ...submissionData.targeting.architectureTypesInclusions,
      ];
      setCpuTypes([...newArchitectureInclusions]);
    }
  }, [submissionData]);

  const sendPostSubmissionCall = (selectedData) => {
    const newSubmissionData = { ...submissionData };
    if (
      selectedData.length !== architectures.length &&
      !selectedData.includes("ALL")
    ) {
      newSubmissionData.targeting.architectureTypesInclusions = [
        ...selectedData,
      ];
    } else {
      newSubmissionData.targeting.architectureTypesInclusions = ["ALL"];
    }
    delete newSubmissionData["legalDocuments"];
    postCallTheNewSubmission(newSubmissionData);
  };

  return (
    <section className="cpu">
      <div className="wrapper-diver">
        <p className="text-cpu-title">
          CPU <span className="required">*</span>
        </p>
        <div style={{ marginTop: "6px !important" }}>
          {submissionData &&
          Object.keys(submissionData).length > 0 &&
          submissionData.status === "DRAFT" ? (
            <Button
              className="set-button"
              variant="outlined"
              onClick={handleOpen}
              style={{
                textTransform: "none",
              }}
            >
              Set
            </Button>
          ) : (
            <Button
              className="set-button"
              variant="outlined"
              onClick={handleOpen}
              style={{
                textTransform: "none",
              }}
            >
              View
            </Button>
          )}
        </div>
      </div>
      {
        <div className="wrapper-diver">
          <div>
            <Grid2 direction="row" rowsGap={5} spacing={2}>
              {cpuTypes &&
              cpuTypes.length > 0 &&
              cpuTypes.length === 1 &&
              cpuTypes[0] === "ALL"
                ? architectures.map((cpu) => {
                    return (
                      cpu !== "ALL" && (
                        <Chip
                          sx={{
                            "font-weight": 400,
                            "font-size": "12px",
                            // "line-height": "19.6px",
                            // "letter-spacing": "0.4px",
                            color: "#5A5B5C",
                            height: "24px !important",
                          }}
                          key={cpu}
                          label={cpu}
                          className="chip-text"
                          style={{
                            borderRadius: "5px",
                            marginRight: "8px",
                            marginBottom: "8px",
                          }}
                        ></Chip>
                      )
                    );
                  })
                : cpuTypes &&
                  cpuTypes.length > 0 &&
                  cpuTypes.map((cpu) => {
                    return (
                      cpu !== "ALL" && (
                        <Chip
                          sx={{
                            "font-weight": 400,
                            "font-size": "12px",
                            height: "24px !important",
                            // "line-height": "19.6px",
                            // "letter-spacing": "0.4px",

                            color: "#5A5B5C",
                          }}
                          key={cpu}
                          label={cpu}
                          className="chip-text"
                          style={{
                            borderRadius: "5px",
                            marginRight: "8px",
                            marginBottom: "8px",
                          }}
                        ></Chip>
                      )
                    );
                  })}
            </Grid2>
          </div>
        </div>
      }
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        <Box sx={{ ...style, width: 700, height: 460 }}>
          <h2 id="parent-modal-title">Targeting-CPU Types</h2>
          <div style={{ position: "absolute", right: "30px", top: "45px" }}>
            <IconButton>
              <CloseIcon onClick={handleClose} />
            </IconButton>
          </div>
          <section>
            <ApplicationModal
              handleClose={handleClose}
              selectedData={cpuTypes}
              availabilty={architectures}
              name={name}
              sendPostSubmissionCall={sendPostSubmissionCall}
              status={submissionData.status}
            />
          </section>
        </Box>
      </Modal>
    </section>
  );
}

ApplicationDetailsCPU.propTypes = {
  architectures: PropTypes.arrayOf(PropTypes.string).isRequired,
  submissionData: PropTypes.shape({ 
    status: PropTypes.string,
    targeting: PropTypes.shape({
      architectureTypesInclusions: PropTypes.arrayOf(PropTypes.string),
    }),
  }).isRequired,
  postCallTheNewSubmission: PropTypes.func.isRequired,
};

export default ApplicationDetailsCPU;
